<template>
  <div>
    <div class="tableDetail" v-for="(item, index) in tableData" :key="index">
      <div class="top">
        <span class="name" :title="item.packName">{{ item.packName }}</span>

        <template v-if="item.joinFlag == 1 && flag == 3">
          <el-tag type="success">{{ $t("page.content.Attended") }}</el-tag>
        </template>
        <template v-if="item.joinFlag == 0 && flag == 3">
          <el-tag type="danger">{{ $t("page.content.NotAttend") }}</el-tag>
        </template>
        <!-- 后期只留下2 -->
        <template v-if="flag == 2 && type != 1">
          <!-- 是否参与 -->
          <span class="radio"
            >{{ $t("page.content.YesOrNo") }}：
            <el-radio-group v-model="item.joinFlag" @change="joinFlagChange">
              <!-- 是 -->
              <el-radio label="1">{{ $t("page.content.Yes") }}</el-radio>
              <!-- 否 -->
              <el-radio label="0">{{ $t("page.content.no") }}</el-radio>
            </el-radio-group>
          </span>
        </template>
      </div>
      <!-- <hr style="border:1px solid #EDF2FC;width:100%" /> -->
      <div class="center">
        <!-- 包件说明： -->
        <p class="chlidName">
          {{ $t("page.content.PackageDescription") }}：{{ item.packRequire }}
        </p>
      </div>
      <div class="footer" v-if="purchaseType != 50 && purchaseType != 53">
        <!-- 物资信息 -->
        <p class="chlidName">{{ $t("page.content.Requirements") }}:</p>
        <div class="tableBox">
          <el-table :data="item.matDetailList" border>
            <!-- 序号 -->
            <el-table-column
              type="index"
              :label="$t('page.content.No')"
              width="55"
            />
            <!-- 设备物质名称 -->
            <el-table-column
              prop="matName"
              :label="$t('page.content.Item')"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                {{ row.matName ? row.matName : "" }}
              </template>
            </el-table-column>
            <!-- 设备物质说明 -->
            <el-table-column
              prop="matDesc"
              :label="$t('page.content.ItemDescription')"
              min-width="170"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                {{ row.matDesc ? row.matDesc : "" }}
              </template>
            </el-table-column>
            <!-- 数量 -->
            <el-table-column
              prop="convNum"
              min-width="100"
              :label="$t('page.content.QTY')"
              width="120"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                {{ row.convNum ? row.convNum : "" }}
              </template>
            </el-table-column>
            <!-- 单位 -->
            <el-table-column
              prop="convMeasureUnitName"
              :label="$t('page.content.Unit')"
              min-width="120"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                {{ row.convMeasureUnitName ? row.convMeasureUnitName : "" }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    },
    //判断是否可以参与
    flag: {
      type: String,
      default: "2"
    },
    //方案类型
    purchaseType: {
      type: String,
      default: ""
    },
    //判断是否参与
    joinFlag: {
      type: String,
      default: "1"
    },
    //判断是否从中标结果通知详情进入 1为是
    type: {
      type: String,
      default: "2"
    }
  },
  data() {
    return {
      form: {
        joinFlag: "1"
      },
      joinFlags: this.joinFlag
    };
  },
  methods: {
    joinFlagChange(value) {
      console.log(value, "value");
    }
  }
};
</script>
<style lang="scss" scoped>
.tableDetail {
  padding-bottom: 10px;
  border: 1px solid #edf2fc;
  margin-bottom: 15px;
  .top {
    padding: 0px 10px;
    display: flex;
    align-items: center;
    color: #4a4a4a;
    height: 40px;
    border-bottom: 1px solid rgb(237, 242, 252);
    font-size: 14px;
    font-weight: 600;
    color: red;
    .el-tag {
      height: 25px;
      line-height: 25px;
    }
    .name {
      padding-right: 20px;
      font-size: 14px;
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .center {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
  }
  .footer {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;

    .tableBox {
      padding: 0px 20px;
    }
  }
  .chlidName {
    padding-bottom: 10px;
    word-break: break-all;
  }
}
/deep/.el-table__row {
  line-height: 36px;
  height: 36px;
}
</style>
